import axios from "../../axiosConfig";
import { put, call } from "redux-saga/effects";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  CREATE_BULLETIN_SUCCESS,
  CREATE_BULLETIN_FAILED,
  GET_BULLETIN_DRAFT_SUCCESS,
  GET_BULLETIN_DRAFT_FAILED,
  UPDATE_BULLETIN_DRAFT_SUCCESS,
  UPDATE_BULLETIN_DRAFT_FAILED,
  PUBLISHED_BULLETIN_STATUS_FAILED,
  PUBLISHED_BULLETIN_STATUS_SUCCESS,
  SEARCH_BULLETIN_SUCCESS,
  SEARCH_BULLETIN_FAILED,
  SEARCH_BULLETIN_REQUEST,
  DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS,
  DRAFT_BULLETIN_ACTIVE_STATUS_FAILED,
  REMOVE_BULLETIN_SUCCESS,
  REMOVE_BULLETIN_FAILED,
} from "../Actions/BulletinAction";
import decryptResponse from "../../Components/Decrypt";

export function* createBulletinSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/create-bulletin`,
      action?.payload
    );
    const { data, message } = response?.data;
    yield put({ type: CREATE_BULLETIN_SUCCESS, payload: data });
    yield put({
      type: SEARCH_BULLETIN_REQUEST,
      payload: {
        type: "publish",
        key: "",
        perpage: 10,
        page: 1,
      },
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: CREATE_BULLETIN_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getBulletinDraftSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-bulletin-details-by-Id/${action.payload}`
    );
    const { data } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_BULLETIN_DRAFT_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_BULLETIN_DRAFT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* updateBulletinDraftSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/edit-bulletin-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: UPDATE_BULLETIN_DRAFT_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: UPDATE_BULLETIN_DRAFT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* publishedBulletinSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-bulletin-status`,
      action.payload
    );
    const { success, message, errors } = response?.data;
    yield put({
      type: PUBLISHED_BULLETIN_STATUS_SUCCESS,
      payload: action.payload,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: PUBLISHED_BULLETIN_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message || e,
        severity: "error",
      },
    });
  }
}

export function* bulletinSearchSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-search-bulletin-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: SEARCH_BULLETIN_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: SEARCH_BULLETIN_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* draftBulletinActiveSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-bulletin-active-status`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: DRAFT_BULLETIN_ACTIVE_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* RemoveBulletinSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-bulletin-details/${action?.payload?.Id}`
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: REMOVE_BULLETIN_SUCCESS, payload: action?.payload?.Id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_BULLETIN_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
